import {Layout} from "@components";
import React, {useEffect, useMemo, useState} from "react";
import {useRecoilValue} from "recoil";
import {states} from "@recoils";
import {Autoplay} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/swiper.css";
import styles from "./style.module.scss";
import {Images, ScreenId} from "@assets";
import {useLogin, useNav} from "@hook";
import {api, constant, cookieUtil} from "@utils";
import * as Datas from "@data";
import {Modal} from "@adminComponents";

const popupHideCookieKey = "isPopupHide";
const COOKIE_VALUE = "1";

export default function HomePage() {
  const {userData} = useLogin();
  const {navigate} = useNav();
  const infoData = useRecoilValue(states.infoDataState);
  const advData = useRecoilValue(states.advDataState);
  const [aListCur, setAListCur] = useState(0);
  const [popupList, setPopupList] = useState<Datas.IPopupResponse[]>();
  const [popupCur, setPopupCur] = useState(0);
  const isPc = window.innerWidth > constant.TABLET_WIDTH;

  const {aAdvList, aLength, otherAdvList} = useMemo(() => {
    const aAdvList = advData
      .filter(item => (item.type || "").toLocaleUpperCase() === "A")
      .filter(item => item.files?.[0]?.url);
    const bAdv = advData.find(
      item => (item.type || "").toLocaleUpperCase() === "B",
    );
    const cAdv = advData.find(
      item => (item.type || "").toLocaleUpperCase() === "C",
    );
    const dAdv = advData.find(
      item => (item.type || "").toLocaleUpperCase() === "D",
    );
    const eAdv = advData.find(
      item => (item.type || "").toLocaleUpperCase() === "E",
    );
    const otherAdvList = [bAdv, cAdv, dAdv, eAdv].filter(
      item => !!item?.files?.[0]?.url,
    );

    return {
      aAdvList: [
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
        ...aAdvList,
      ],
      aLength: aAdvList.length,
      bAdv,
      cAdv,
      dAdv,
      eAdv,
      otherAdvList,
    };
  }, [advData]);
  const clubData = useMemo(() => {
    return infoData.find(item => item.type === "club");
  }, [infoData]);

  async function getPopupList() {
    try {
      const cookie = cookieUtil.getCookie({name: popupHideCookieKey});
      if (cookie === COOKIE_VALUE) {
        return;
      }
      const {data, success} = await api.v1.popup.getList();
      if (success) {
        setPopupList(data.result);
      }
    } catch (error) {
      console.error("getPopupList error", error);
    }
  }

  function goToMenu(url: ScreenId) {
    if (
      [ScreenId.HOME, ScreenId.LOGIN, ScreenId.KAKAO_LOGIN_CALLBACK].includes(
        url,
      )
    ) {
      return navigate({url: url});
    }
    if (!userData) {
      return navigate({url: ScreenId.LOGIN});
    }
    if (userData.confirm !== "1") {
      return alert(
        "현재 계정은 승인 대기 상태입니다.\n관리자 승인 완료까지 잠시만 기다려 주세요.",
      );
    }
    navigate({url: url});
  }

  useEffect(() => {
    getPopupList();
  }, []);

  return (
    <>
      <Layout>
        <div className={styles.container}>
          {aLength > 0 && (
            <div className={styles.aAdvList}>
              <Swiper
                modules={[Autoplay]}
                slidesPerView="auto"
                centeredSlides
                loop={true}
                spaceBetween={isPc ? 29 : 20}
                speed={600}
                grabCursor={true}
                className={styles.swiper}
                onSlideChange={e => setAListCur((e.realIndex || 0) % aLength)}
                autoplay={{delay: 3000, disableOnInteraction: false}}>
                {aAdvList.map((adv, index) => (
                  <SwiperSlide
                    key={index}
                    className={[
                      styles.swiperSlide,
                      adv.link ? styles.active : undefined,
                    ].join(" ")}
                    onClick={() => {
                      if (adv?.link) {
                        window.open(adv.link, "_blank");
                      }
                    }}>
                    <img src={adv.files?.[0]?.url} alt={adv.title || ""} />
                  </SwiperSlide>
                ))}
              </Swiper>
              {/* <Swiper
                modules={[Autoplay]}
                observer
                observeParents
                >
              </Swiper> */}
              <div className={styles.mainSwiperPagination}>
                <div className={styles.paginationInner}>
                  <div className={styles.paginationLine}>
                    <span
                      style={{
                        width: `${((aListCur + 1) / aLength) * 100}%`,
                      }}
                    />
                  </div>
                  <div className={styles.paginationText}>
                    <span>{(aListCur || 0) + 1}</span> / {aLength}
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className={styles.advList}>
            {otherAdvList.map(item => (
              <div
                key={item?.no}
                className={[
                  styles.advItem,
                  !!item?.link ? styles.active : undefined,
                ].join(" ")}
                onClick={() => {
                  if (item?.link) {
                    window.open(item.link, "_blank");
                  }
                }}>
                <img src={item?.files?.[0]?.url} alt={item?.title || "adv"} />
              </div>
            ))}
          </div>
          {!!clubData && (
            <div className={styles.clubContainer}>
              <div className={styles.img}>
                <img
                  src={clubData.files?.[0]?.url ?? Images.noImage}
                  alt="광주하남 카네기 CEO클럽 소개"
                />
              </div>
              <div className={styles.textContainer}>
                <div className={styles.clubTitle}>{clubData.title}</div>
                <div className={styles.clubSubTitle}>{clubData.sub_title}</div>
                <div className={styles.clubContent}>{clubData.content}</div>
                <div
                  className={styles.btn}
                  onClick={() => goToMenu(ScreenId.ABOUT)}>
                  회장 인사말
                </div>
              </div>
            </div>
          )}
          <div className={styles.noticeContainer}>
            <img src={Images.homeBackImg} alt="공지사항" />
            <div className={styles.textContainer}>
              <div className={styles.title}>Carnegie CEO Club Notice</div>
              <div className={styles.subTitle}>
                광주하남카네기 CEO클럽에
                <br />
                최신 소식은 공지사항을 통해 확인해 주세요.
              </div>
              <div
                className={styles.btn}
                onClick={() => goToMenu(ScreenId.NOTICE)}>
                공지사항
              </div>
            </div>
          </div>
        </div>
      </Layout>
      {!!popupList && (popupList || []).length > 0 && (
        <Modal visible={!!popupList} className={styles.modalContainer}>
          <div className={styles.modal}>
            <div className={styles.imgContainer}>
              <Swiper
                modules={[Autoplay]}
                loop
                centeredSlides
                slidesPerView="auto"
                spaceBetween={0}
                speed={600}
                threshold={5}
                observer
                observeParents
                initialSlide={1}
                autoplay={{delay: 3000, disableOnInteraction: false}}
                onSlideChange={e => setPopupCur(e.realIndex || 0)}>
                {popupList.map((popup, index) => (
                  <SwiperSlide key={index}>
                    <img src={popup.files?.[0]?.url} alt={popup.title || ""} />
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className={styles.pageContainer}>
                {[...new Array(popupList.length).fill(true)].map((_, index) => (
                  <div
                    key={index}
                    className={[
                      styles.pageItem,
                      index === popupCur ? styles.active : undefined,
                    ].join(" ")}
                  />
                ))}
              </div>
            </div>
            <div className={styles.btnContainer}>
              <button
                className={styles.btn}
                onClick={() => {
                  cookieUtil.setCookie({
                    name: popupHideCookieKey,
                    value: COOKIE_VALUE,
                    expire: 1,
                  });
                  setPopupList(undefined);
                }}>
                오늘은 그만 볼래요
              </button>
              <div className={styles.division}>|</div>
              <button
                className={styles.btn}
                onClick={() => setPopupList(undefined)}>
                닫기
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}
